<template>
    <a-col :span="24" slot="content" style="border-top: 1px solid #d1d5da;border-radius: 3px">
      <a-row v-for="(item, index) in list" :key="index">
        <ent-item :item="item" :index="index" @linkchange="linkChange"/>
      </a-row>
    </a-col>
</template>

<script>
import EntItem from '@/com/Ent/EntItem.vue'

export default {
  name: 'EntList',
  props: {
    list: {
      default: function() {
        return []
      }
    },
    user_tags: {
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      relitem: {}
    }
  },
  components: {
    EntItem
  },
  filters: {
  },
  methods: {
    linkChange: function(item, tag) {
      this.relitem = this.$store.getters.getRelationItem()
      if (tag) {
        this.relitem[item] = tag
      } else {
        delete this.relitem[item]
      }
      this.$emit('checked', this.relitem);
    }
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
